import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { PersonalDataResponseDto } from '@app/data/dtos/personal-data/personal-data/personal-data-response.dto';
import { Knowledge } from '@app/entities/interfaces/personal-data/employee-languages.interface';
import { ModifyStudy } from '@app/entities/interfaces/personal-data/studies.interface';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { PersonalDataAddress } from '@app/entities/models/personal-data/address.model';
import {
  CertificateEmployeeModel,
  EmployeeLanguages,
  LanguageMastersModel
} from '@app/entities/models/personal-data/employee-languages.model';
import { MaritalStatus } from '@app/entities/models/personal-data/marital-status.model';
import { PersonalData } from '@app/entities/models/personal-data/personal-data.model';
import {
  Qualification,
  QualificationEducationalLevels,
  QualificationStatuses,
  Study
} from '@app/entities/models/personal-data/studies.model';
import { UpdateEmergencyContact } from '@app/entities/models/personal-data/update-emergency-contact.model';
import { UpdatePhone } from '@app/entities/models/personal-data/update-phone.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

export interface PersonalDataRepository {
  getPersonalData(): Observable<PersonalData>;
  updateEmail(email: string, authorization: TwoFactorAuthorization): Observable<PersonalDataResponseDto>;
  createPersonalPhone(
    phoneData: UpdatePhone,
    authorization: TwoFactorAuthorization
  ): Observable<PersonalDataResponseDto>;
  updatePersonalPhone(
    updatePhoneData: UpdatePhone,
    phoneId: string,
    authorization: TwoFactorAuthorization
  ): Observable<PersonalDataResponseDto>;
  deletePhone(phoneSectionId: string): Observable<PersonalDataResponseDto>;
  createEmergencyContact(emergencyContactData: UpdateEmergencyContact): Observable<PersonalDataResponseDto>;
  updateEmergencyContact(
    emergencyContactData: UpdateEmergencyContact,
    phoneId: string
  ): Observable<PersonalDataResponseDto>;
  updateAddress(
    address: PersonalDataAddress,
    authorization: TwoFactorAuthorization
  ): Observable<PersonalDataResponseDto>;
  getEmployeeLanguages(): Observable<MSafeAny>;
  getLanguagesMasters(): Observable<LanguageMastersModel>;
  getLanguagesData(): Knowledge[] | undefined;
  getStudiesData(): Study[] | undefined;
  getEmployeeStudies(): Observable<MSafeAny>;
  getQualifications(
    countryIsoNumericCode: string,
    educationalLevelId: string,
    page: number,
    name?: string
  ): Observable<Qualification>;
  getQualificationStatuses(): Observable<QualificationStatuses>;
  getQualificationEducationalLevels(countryIsoNumericCode: string): Observable<QualificationEducationalLevels>;
  createEmployeeCertificate(certificate: CertificateEmployeeModel): Observable<EmployeeLanguages>;
  updateEmployeeCertificate(certificate: CertificateEmployeeModel): Observable<EmployeeLanguages>;
  addStudyToEmployee(qualification: ModifyStudy): Observable<object>;
  updateEmployeeStudy(qualification: ModifyStudy): Observable<object>;
  deleteEmployeeCertificate(languageId: string): Observable<object>;
  deleteStudy(studyId: string, countryIsoNumericCode: string): Observable<object>;
  getMaritalStatusOptions(): Observable<MaritalStatus[]>;
  updateMaritalStatus(id: string, authorization: TwoFactorAuthorization): Observable<object>;
}

export const PERSONAL_DATA_REPOSITORY = new InjectionToken<PersonalDataRepository>('PERSONAL_DATA_REPOSITORY');
